var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LinkButton } from '@hn-ui/buttons';
import { Back } from '@hn-ui/icons';
import { styled } from 'styled-components';
import { PageContainer } from '../../../Common/components/PageContainer';
import { ASSIGNMENTS_ROUTES } from '../../constants/routes';
import { PageValidator } from '../PageValidator';
import { usePostEvent } from '../../../Common/hooks/usePostEvent';
var Page = styled(PageContainer).withConfig({ displayName: "Page", componentId: "sc-gzrep9" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  --webkit-text-size-adjust: none;\n  text-size-adjust: none;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n\n  box-sizing: border-box;\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n"], ["\n  --webkit-text-size-adjust: none;\n  text-size-adjust: none;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n\n  box-sizing: border-box;\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n"])));
var ScBackLink = styled(LinkButton).withConfig({ displayName: "ScBackLink", componentId: "sc-mpd1i0" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: auto;\n  margin-bottom: 36px;\n  gap: 0 4px;\n"], ["\n  width: auto;\n  margin-bottom: 36px;\n  gap: 0 4px;\n"])));
var AssignmentsLayout = function (_a) {
    var _b;
    var groupInfo = _a.groupInfo, groupInfoLoading = _a.groupInfoLoading;
    var location = useLocation();
    var navigate = useNavigate();
    var referrer = (_b = location.state) === null || _b === void 0 ? void 0 : _b.referrer;
    var onBackClick = useCallback(function () {
        if (referrer) {
            navigate(-1);
            return;
        }
        navigate(ASSIGNMENTS_ROUTES.assignmentsList);
    }, [navigate, referrer]);
    var isIndex = matchPath(ASSIGNMENTS_ROUTES.assignmentsList, location.pathname);
    var comesFromDetails = referrer && matchPath(ASSIGNMENTS_ROUTES.assignmentDetails, referrer);
    var postEvent = usePostEvent()[0];
    useEffect(function () {
        postEvent('assignment_page').then();
    }, []);
    return (_jsx(Page, { children: _jsxs(PageValidator, __assign({ groupInfo: groupInfo, groupInfoLoading: groupInfoLoading }, { children: [!isIndex && (_jsx(ScBackLink, __assign({ LeftIcon: Back, onClick: onBackClick }, { children: _jsx("span", { children: "back to " + (comesFromDetails ? 'assignment details' : 'assignments list') }, void 0) }), void 0)), _jsx(Outlet, {}, void 0)] }), void 0) }, void 0));
};
export { AssignmentsLayout };
var templateObject_1, templateObject_2;
